<script setup lang="ts">
import BaseValue from '@/components/BaseValue.vue';
import { UsdValue } from '@sonarwatch/portfolio-core';
import { unknownImageUrl } from '@/constants';
import usePlatforms from '@/helpers/usePlatforms';
import { computed } from 'vue';
import { twMerge } from 'tailwind-merge';
const props = defineProps<{
  platformId: string;
  value?: UsdValue;
}>();
const { getPlatformById, isFetching } = usePlatforms();

const platform = computed(() => getPlatformById(props.platformId));
const title = computed(() => {
  const name = platform?.value?.name || props.platformId;
  // @disabled-jup
  // Temp fix for Jupiter
  if (name === 'Tokens') {
    return 'Holdings';
  }
  return name;
});
const image = computed(() => platform?.value?.image || unknownImageUrl);
const website = computed(() => platform?.value?.website);
</script>

<template>
  <div class="flex flex-row w-full">
    <div
      :class="
        twMerge(
          'flex flex-row py-4 flex-1 items-center gap-2 opacity-0  min-w-0',
          !isFetching && 'opacity-100',
        )
      "
    >
      <v-avatar size="x-small">
        <v-img :src="image" :alt="`${title} logo`" />
      </v-avatar>
      <div
        class="text-xl font-medium flex flex-row items-center flex-1 min-w-0"
      >
        <p class="text-ellipsis text-nowrap min-w-0 overflow-hidden">
          {{ title }}
        </p>
        <a
          v-if="website"
          :href="website"
          target="_blank"
          @click="$event.stopPropagation()"
          rel="noopener noreferrer"
          class="text-decoration-none position-relative platform-link"
        >
          <v-icon size="14px" icon="mdi-open-in-new" class="mx-2 my-2"></v-icon>
        </a>
      </div>
    </div>

    <div class="text-right pr-4 align-content-center shrink-0">
      <BaseValue :value="value" />
    </div>
  </div>
</template>
